import Vue from 'vue'
import Vuex from 'vuex'
import backendeleres from './backendeleres.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bejelentkezve: undefined,
    backendeleres: backendeleres.backendeleres,
    minosites: 0,
    id:0,
    diakJelolSzilenciumot: false,
    diakJelolTermet: false
  },
  mutations: {
    bejelentkezve(state,allas){
      state.bejelentkezve=allas;
    },
    minosites(state,allas){
      state.minosites=allas
    },
    id(state,allas){
      state.id=allas
    },
    diakJelolSzilenciumot(state,allas){
      state.diakJelolSzilenciumot=allas
    },
    diakJelolTermet(state,allas){
      state.diakJelolTermet=allas
    }

  },
  actions: {
    bejelentkezesallasvaltas({commit}, bejelentkezve){
      commit('bejelentkezve',bejelentkezve)
    }
  },
  modules: {
  }
})
